import {
  Text,
  GreyGrey0,
  GreyGrey30,
  GreyGrey60,
  IndigoIndigo50,
  Primary13SemiBold,
  IconChevronRight,
  Flex
} from '@sequencehq/core-components'
import { Fragment } from 'react'
import { usePricingEditorDomainContext } from 'common/drawers/PricingEditor/communication'

export const EditorBreadcrumb = () => {
  const pricingEditorContext = usePricingEditorDomainContext()
  const steps = pricingEditorContext.queries.breadcrumbSteps
  const activeStepIndex = steps.findIndex(step => step.active)

  return (
    <Flex
      alignItems="center"
      padding="20px 16px"
      borderBottom={`1px solid ${GreyGrey30}`}
      backgroundColor={GreyGrey0}
      data-testid="editorBreadcrumb"
    >
      {steps.map((step, index) => (
        <Fragment key={step.name}>
          <Text
            {...Primary13SemiBold}
            color={step.active ? IndigoIndigo50 : GreyGrey60}
            cursor={index < activeStepIndex ? 'pointer' : 'default'}
            userSelect="none"
            data-testid={`editorBreadcrumb.step.${index}`}
            onClick={() => {
              if (index < activeStepIndex) {
                pricingEditorContext.mutators.common.updateConfiguration({
                  mode: step.mode
                })
              }
            }}
          >
            {step.name}
          </Text>
          {index < steps.length - 1 && <IconChevronRight color={GreyGrey60} />}
        </Fragment>
      ))}
    </Flex>
  )
}
